module.exports = __webpack_public_path__ + "static/media/Z-Letter-PNG-Photo.5b4e4466.png";